import React, { Fragment } from 'react'
import { Input, TextArea, Button, Form, Icon } from '@drifthq/tide-core'
import { Select } from '@drifthq/tide-selects'
import { Link } from 'react-router-dom'
import * as R from 'ramda'
import './style.css'

import { Locale } from 'modules/org/constants'
import PreviewInput from 'components/PreviewInput'
import { messagesByLocale } from 'utils/translations'

const LOCALE_OPTIONS = [
  { value: Locale.zh, label: "Chinese, Simplified (ZH_HANS)" },
  { value: Locale.hr, label: "Croatian (HR)" },
  { value: Locale.da, label: "Danish (DK)" },
  { value: Locale.nl, label: "Dutch (NL)" },
  { value: Locale.en, label: "English (EN)" },
  { value: Locale.et, label: "Estonian (ET)" },
  { value: Locale.fi, label: "Finnish (FI)" },
  { value: Locale.fr, label: "French (FR)" },
  { value: Locale.ka, label: "Georgian (KA)" },
  { value: Locale.de, label: "German (DE)" },
  { value: Locale['de-DE-formal'], label: "German (DE-formal)" },
  { value: Locale.hi, label: "Hindi (HI)" },
  { value: Locale.hu, label: "Hungarian (HU)" },
  { value: Locale.is, label: "Icelandic (IS)" },
  { value: Locale.it, label: "Italian (IT)" },
  { value: Locale.ko, label: "Korean (KR)" },
  { value: Locale.nb, label: "Norwegian (NO)" },
  { value: Locale.pl, label: "Polish (PL)" },
  { value: Locale.pt, label: "Portuguese (PT)" },
  { value: Locale['pt-BR'], label: "Portuguese (BR)" },
  { value: Locale.ro, label: "Romanian (RO)" },
  { value: Locale.ru, label: "Russian (RU)" },
  { value: Locale.sr, label: "Serbian (SP)" },
  { value: Locale.sl, label: "Slovene (SI)" },
  { value: Locale.es, label: "Spanish (ES)" },
  { value: Locale.sv, label: "Swedish (SV)" },
  { value: Locale.th, label: "Thai (TH)" },
  { value: Locale.tr, label: "Turkish (TR)" },
  { value: Locale.vi, label: "Vietnamese (VN)" }
]

const Welcome = ({
  name,
  onNameChange,
  welcomeMessage,
  onWelcomeMessageChange,
  onContinueClick,
  locale,
  onLocaleChange,
  disabled,
}) => {
return (
  <Fragment>
    <h1>How should you greet visitors?</h1>
    <p className="setup-description">Drift will automatically show this message when someone visits your site</p>
    <Form onSubmit={onContinueClick}>
      <PreviewInput
        label="Language"
        value={R.find(R.propEq('value', locale), LOCALE_OPTIONS).label}
        show={false}
        children
      >
        <Select
          className="welcome-locale-select"
          label="Language"
          options={LOCALE_OPTIONS}
          onChange={onLocaleChange}
          value={R.find(R.propEq('value', locale), LOCALE_OPTIONS)}
          clearable={false}
        />
      </PreviewInput>
      <PreviewInput
        label="Your greeting"
        value={welcomeMessage || messagesByLocale[locale]["app.newConversation.welcomeMessage"]}
        show={false}
        children
      >
        <TextArea
          label="Your greeting"
          className="welcome-message-box"
          onChange={onWelcomeMessageChange}
          defaultValue={welcomeMessage || messagesByLocale[locale]["app.newConversation.welcomeMessage"]}
        />
      </PreviewInput>
      <Input
        className="welcome-name-box"
        label="Full name"
        placeholder="John Doe"
        value={name}
        onChange={onNameChange}
      />
      <div className='welcome-next-step'>
        <Button submit disabled={disabled}>Continue</Button>
        <div className='welcome-nav'>
          <Link
            className='welcome-next'
            to="/setup/touchless/custom"
          >
            <Icon name="arrow-1-left" className="welcome-back-caret"/>
            Back
          </Link>
        </div>
      </div>
    </Form>
  </Fragment>
)}
export default Welcome



// WEBPACK FOOTER //
// ./src/layouts/Welcome/component.js